import styled from "styled-components";
import { Status, Typography } from "../../../../../components/ui-kit";

export const Label = styled(Typography)`
  margin-top: 100px;
  text-align: center;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Card = styled.div`
  padding: 25px 30px;
  border-radius: 10px;
  border: 1px solid #eee;
  background: #fff;
  margin-top: 45px;
`;

export const UpperDoubleCard = styled.div`
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 20px;
  margin-top: 20px;
`;

export const MiddleCard = styled(UpperDoubleCard)`
  border-radius: inherit;
  margin-top: 0;
  border-top: 0;
  padding: 15px 20px;
`;

export const LowerDoubleCard = styled(UpperDoubleCard)`
  margin-top: 0;
  border-top: 0;
  border-top-left-radius: initial;
  border-top-right-radius: initial;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const GreenCaption = styled(Typography)`
  text-transform: uppercase;
  color: #00bc82;
  text-align: start;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const PaymentInfo = styled(Typography)`
  margin-top: 10px;
  margin-bottom: 5px;
`;

export const OrderDetails = styled.div`
  display: flex;
  align-items: center;
  margin-top: 25px;
  gap: 60px;
`;

export const CaptionAndStatus = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1100px) {
    margin-right: 10px;
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledStatus = styled(Status)`
  margin-left: 10px;
`;

export const DetailsAndCostAddsOn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
`;

export const DetailsAndCost = styled(DetailsAndCostAddsOn)`
  margin-top: 5px;
  flex-direction: column;
  align-items: flex-start;
`;

export const DetailItem = styled.div``;

export const DetailInfoText = styled(Typography)`
  text-align: start;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;
